import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND_NAME } from "@/config";
import { useCategories } from "@/hooks/useCategories";
import { SearchBar } from "@/components/SearchBar";

export const Header = () => {
  const { categories } = useCategories();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-white/95 backdrop-blur-sm" data-testid="header">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 md:px-10 md:py-5">
        <button className="md:hidden" data-testid="mobile-toggle" onClick={() => setOpen(!open)}>
          {open ? <X size={24} strokeWidth={1.25} /> : <Menu size={24} strokeWidth={1.25} />}
        </button>

        <Link to="/" data-testid="brand-logo" className="mx-auto text-center md:mx-0 md:text-left">
          <div className="font-serif text-2xl tracking-[0.14em] text-stone-900 md:text-3xl">{BRAND_NAME}</div>
          <div className="mt-1 text-center text-xs font-bold uppercase tracking-[0.3em] text-stone-600 md:text-sm" data-testid="brand-byline">By Allure</div>
        </Link>

        <div className="flex items-center gap-6">
          <SearchBar className="hidden w-56 md:block lg:w-72" />
          <Link to="/admin" data-testid="admin-link" className="hidden text-sm uppercase tracking-[0.18em] text-stone-500 transition-colors hover:text-wine md:block">
            Admin
          </Link>
        </div>
      </div>

      <nav className="hidden justify-center gap-12 border-t border-border py-3.5 md:flex" data-testid="category-nav">
        {categories.map((c) => (
          <Link
            key={c.id}
            to={`/category/${c.slug}`}
            data-testid={`nav-cat-${c.slug}`}
            className="text-sm uppercase tracking-[0.16em] text-stone-700 transition-colors hover:text-wine"
          >
            {c.name}
          </Link>
        ))}
      </nav>

      {open && (
        <nav className="border-t border-border bg-white md:hidden" data-testid="mobile-nav">
          <div className="border-b border-border px-5 py-4">
            <SearchBar />
          </div>
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/category/${c.slug}`}
              onClick={() => setOpen(false)}
              className="block border-b border-border px-5 py-4 text-sm uppercase tracking-[0.16em] text-stone-700"
            >
              {c.name}
            </Link>
          ))}
          <Link to="/admin" onClick={() => setOpen(false)} className="block px-5 py-4 text-sm uppercase tracking-[0.16em] text-stone-500">
            Admin
          </Link>
        </nav>
      )}
    </header>
  );
};
